import { translate } from 'i18n/i18n'
import moment from 'moment-timezone'

export const minutesToHoursAndMinutesAlwaysShowingHours = (numOfMinutes: number) => {
  const duration = moment.duration(Math.round(numOfMinutes), 'minutes')
  // Always display the total hours, ignoring the fraction because we'll output those as 0-59 minutes.
  const hours = Math.floor(duration.asHours())
  const minutes = duration.minutes()

  return translate.phrases.banyanApp('{{hours}}h {{minutes}}m', { hours, minutes })
}
